// extracted by mini-css-extract-plugin
export default {"compressedAssigneeAvatar":"CompressedAssigneeAnchor-module__compressedAssigneeAvatar--joKCf"};